import { Component} from '@angular/core'

@Component({
  selector: 'app-alignment',
  templateUrl: './alignment.component.html',
  styleUrls: ['./alignment.component.scss']
})
export class AlignmentComponent {
}
